import { Box, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, useTheme } from "@mui/material";
import { useState } from "react";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// import { useAuth0 } from "@auth0/auth0-react";
import { logout } from '../slices/loginSlice';
import AdminIcon from '@mui/icons-material/AdminPanelSettings';
import { UserAvatar } from "./UserAvatar";

export const UserMenu = ({ user }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();

    // const user = useSelector((state) => state.login.user);

    // const { logout } = useAuth0();
    const [anchor, setAnchor] = useState(null);
    const open = Boolean(anchor);

    const handleClick = e => {
        setAnchor(e.currentTarget);
    }

    const handleClose = () => {
        setAnchor(null);
    }

    const handleProfile = () => {
        setAnchor(null);
        navigate(`/user/${user.id}/items`);
    }

    const handleLogout = () => {
        setAnchor(null);
        navigate('/popular');
        dispatch(logout());
    }

    const handleLogin = () => {
        setAnchor(null);
        navigate('/login');
    }

    const handleAdmin = () => {
        setAnchor(null);
        navigate('/admin');
    }

    return (
        <div>
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: '10px',
            }}>
                {user ?
                    <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                        <Link to={`/user/${user.id}/items`} style={{ color: theme.palette.appShell.chromeText }}>{`@${user.name}`}</Link>
                    </Box>
                : null}
                <IconButton onClick={handleClick} aria-label="Account menu">
                    <UserAvatar user={user} size="small" />
                </IconButton>
            </div>

            <Menu
                id="user-menu"
                anchorEl={anchor}
                open={open}
                onClose={handleClose}
            >
                {user ?
                    <MenuList>
                        <MenuItem onClick={handleProfile}>
                            <ListItemIcon><AccountBoxIcon fontSize="small"/></ListItemIcon>
                            <ListItemText>Profile</ListItemText>
                        </MenuItem>
                        {user?.isAdmin ?
                            <MenuItem onClick={handleAdmin}>
                                <ListItemIcon><AdminIcon fontSize="small"/></ListItemIcon>
                                <ListItemText>Admin</ListItemText>
                            </MenuItem>
                        : null}
                        <Divider />
                        <MenuItem onClick={handleLogout}>
                            <ListItemIcon><LogoutIcon /></ListItemIcon>
                            <ListItemText>Logout</ListItemText>
                        </MenuItem>
                    </MenuList> :
                    <MenuList>
                        <MenuItem onClick={handleLogin}>
                            <ListItemIcon><AccountBoxIcon fontSize="small"/></ListItemIcon>
                            <ListItemText>Login</ListItemText>
                        </MenuItem>
                    </MenuList>
                }
            </Menu>
        </div>
    );
}
